import { Util, Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/uaapi/user/";

//获取国家相关信息
export function get_countryInfos(query, config) {
  return XtAxios.get(URL + `user/country/countryInfos${query}`, config);
}

//根据国家id和语言获取广告页
export function get_advertising(countryId, config) {
  return XtAxios.get(URL + `user/advertising/${countryId}`, config);
}

//判断当前ip所属国家是否拦截注册
export function get_checkCountryIpIsIntercept(config) {
  return XtAxios.get(URL + `user/country/checkCountryIpIsIntercept`, config);
}

//校验邀请码是否正确
export function get_checkRecommendCode(code, config) {
  return XtAxios.get(URL + `user/checkRecommendCode/${code}`, config);
}

//发送短信邮箱验证码
export function post_msgDoSendCode(config) {
  return XtAxios.post(URL + `msg/doSendCode`, null, {
    ...config,
    noHandle401: true,
  });
}

//用户注册
export function post_reg(config) {
  return XtAxios.post(URL + `reg`, null, config);
}

//用户注册v2
export function post_v2Reg(config) {
  return XtAxios.post(URL + `v2/reg`, null, config);
}

//2fa校验 校验成功获取结果凭证
export function get_faCheckToken(config) {
  return XtAxios.get(URL + `user/fa/getFaResult`, config);
}

//用户通过2fa验证找回密码
// export function put_retrieveThePasswordByFa(config) {
//   return XtAxios.put(URL + `user/retrieveThePasswordByFa`, null, config);
// }
//用户通过2fa验证找回密码
export function put_nResetPasswd(config) {
  return XtAxios.put(URL + `user/fa/item/resetPasswd`, null, config);
}

//找回密码前置校验通过后下发2fa验证项以及优先级
// export function get_retrieveThePasswordByFaBeforeCheck(config) {
//   return XtAxios.get(URL + `user/retrieveThePasswordByFaBeforeCheck`, config);
// }
//找回密码前置校验通过后下发2fa验证项以及优先级
export function get_getFaCheckItem(config) {
  return XtAxios.get(URL + `user/fa/getFaCheckItem`, config);
}

//获取用户基本信息
export function get_userGetUserInfo(config) {
  return XtAxios.get(URL + `user/getUserInfo`, config);
}

/** GET /uaapi/user/public/user-tags — 全站功能标签灰度配置（推全 / 受控） */
export function get_publicUserTags(config) {
  return XtAxios.get(URL + `public/user-tags`, {
    ...config,
    isAutoPopError: false,
  });
}

// 获取用户认证信息
export function get_kycGetRealAuthInfo(config) {
  return XtAxios.get(URL + `user/kyc/getRealAuthInfo`, config);
}

// 查询 KYC 详情信息
export function get_resetKycInfo(config) {
  return XtAxios.get(URL + `user/fa/item/getResetKycInfo`, config);
}

//补全用户常住国家信息
export function post_addUserCountry(config) {
  return XtAxios.post(
    URL + `/user/addUserCountry/${config.params.countryId}`,
    null,
    config
  );
}
